// SVELT product page behaviour: bundle tiers, countdown, sticky add-to-cart, read-more.
(() => {
  const formatMoney = (cents, format) => {
    const value = (cents / 100).toFixed(2);
    const [whole, dec] = value.split('.');
    const withSep = (sep) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withSep(',');
        case 'amount_with_comma_separator': return `${withSep('.')},${dec}`;
        case 'amount_no_decimals_with_comma_separator': return withSep('.');
        case 'amount_with_space_separator': return `${withSep(' ')},${dec}`;
        case 'amount_with_apostrophe_separator': return `${withSep("'")}.${dec}`;
        default: return `${withSep(',')}.${dec}`;
      }
    });
  };

  const pickGet = (el) => (el.tagName === 'SELECT' ? el.value : el.dataset.value);
  const pickSet = (el, value) => {
    if (el.tagName === 'SELECT') { el.value = value; return; }
    el.dataset.value = value;
    el.querySelectorAll('[data-swatch-value]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.swatchValue === value)));
  };
  if (!customElements.get('svelt-bundle')) {
    customElements.define('svelt-bundle', class extends HTMLElement {
      connectedCallback() {
        this.quantityInput = this.querySelector('[data-bundle-quantity]');
        this.tiers = [...this.querySelectorAll('[data-tier]')];
        this.tiers.forEach((tier) => tier.querySelector('input').addEventListener('change', () => this.select(tier)));
        this.setupPicks();
        this.select(this.tiers.find((t) => t.querySelector('input').checked) || this.tiers[0]);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.dataset.sectionId || !data.variant) return;
            this.mainVariant = data.variant;
            this.syncPicks();
            this.dataset.price = data.variant.price;
            this.dataset.comparePrice = this.dataset.compareBase === 'price' ? data.variant.price : (data.variant.compare_at_price || data.variant.price);
            this.updatePrices();
            this.showMainPrice();
          });
        }
      }
      disconnectedCallback() { this.unsubscribe?.(); if (this.onSubmit) document.removeEventListener('submit', this.onSubmit, true); }
      select(tier) {
        if (!tier) return;
        this.selected = tier;
        this.tiers.forEach((t) => t.classList.toggle('is-selected', t === tier));
        tier.querySelector('input').checked = true;
        if (this.quantityInput) this.quantityInput.value = tier.dataset.quantity;
        if (this.picks && this.picks.parentElement !== tier) tier.appendChild(this.picks);
        this.renderPicks(Number(tier.dataset.quantity), tier.dataset.addon);
        this.showMainPrice();
      }
      // Per-item choices: one colour/size row per item; each row becomes its own cart line.
      setupPicks() {
        this.picks = this.querySelector('[data-picks]');
        if (!this.picks) return;
        try { this.pickVariants = JSON.parse(this.picks.querySelector('[data-pick-variants]').textContent); } catch (e) { this.picks = null; return; }
        this.pickRows = this.picks.querySelector('[data-pick-rows]');
        this.pickTemplate = this.picks.querySelector('[data-pick-template]');
        this.pickInputs = this.picks.querySelector('[data-pick-inputs]');
        this.pickLabel = this.querySelector('[data-pick-label-format]')?.textContent.trim() || '#[n]';
        this.pickVary = this.querySelector('[data-pick-vary]')?.dataset.pickVary === 'true';
        this.addons = {};
        this.picks.querySelectorAll('[data-addon-variants]').forEach((el) => {
          const key = el.dataset.addonVariants;
          try { this.addons[key] = { variants: JSON.parse(el.textContent), template: this.picks.querySelector(`[data-addon-template="${key}"]`) }; } catch (e) {}
        });
        this.form = document.getElementById(this.dataset.formId);
        this.pickRows.addEventListener('change', (event) => {
          const row = event.target.closest('[data-pick]');
          if (row) row.dataset.touched = 'true';
          this.writePickInputs();
        });
        this.pickRows.addEventListener('click', (event) => {
          const swatch = event.target.closest('[data-swatch-value]');
          if (!swatch) return;
          event.preventDefault();
          const row = swatch.closest('[data-pick]');
          pickSet(swatch.closest('[data-pick-option]'), swatch.dataset.swatchValue);
          row.dataset.touched = 'true';
          this.writePickInputs();
        });
        // Swap the single "id + quantity" for one line per item just before the product form reads itself
        this.onSubmit = (event) => {
          if (event.target !== this.form || !this.picksActive()) return;
          const single = [...this.form.querySelectorAll('[name="id"], [name="quantity"]'), ...document.querySelectorAll(`[name="id"][form="${this.form.id}"], [name="quantity"][form="${this.form.id}"]`)];
          single.forEach((el) => { el.dataset.sveltWasDisabled = el.disabled; el.disabled = true; });
          setTimeout(() => single.forEach((el) => { el.disabled = el.dataset.sveltWasDisabled === 'true'; }), 0);
        };
        document.addEventListener('submit', this.onSubmit, true);
      }
      picksActive() { return !!this.picks && !this.picks.hidden && this.pickRows.children.length > 1; }
      currentOptions() {
        const id = Number(this.form?.querySelector('[name="id"]')?.value);
        const variant = this.mainVariant || this.pickVariants.find((v) => v.id === id) || this.pickVariants[0];
        return variant.options;
      }
      variantsFor(row) { return row.dataset.addon ? this.addons[row.dataset.addon]?.variants || [] : this.pickVariants; }
      renderPicks(qty, addonKey) {
        if (!this.picks) return;
        const addon = addonKey ? this.addons[addonKey] : null;
        this.picks.hidden = qty + (addon ? 1 : 0) <= 1;
        // Rebuild when switching between tiers with and without an add-on
        if ((this.pickAddon || '') !== (addon ? addonKey : '')) this.pickRows.innerHTML = '';
        this.pickAddon = addon ? addonKey : '';
        const rows = [...this.pickRows.querySelectorAll('[data-pick]:not([data-addon])')];
        rows.slice(qty).forEach((row) => row.remove());
        for (let i = rows.length; i < qty; i++) {
          const row = this.pickTemplate.content.firstElementChild.cloneNode(true);
          const options = this.defaultOptions(i);
          row.querySelectorAll('[data-pick-option]').forEach((el) => pickSet(el, options[el.dataset.pickOption]));
          this.pickRows.querySelector('[data-addon]') ? this.pickRows.querySelector('[data-addon]').before(row) : this.pickRows.appendChild(row);
        }
        if (addon && !this.pickRows.querySelector('[data-addon]')) {
          const row = addon.template.content.firstElementChild.cloneNode(true);
          row.dataset.addon = addonKey;
          this.setAddonDefaults(row, addon);
          this.pickRows.appendChild(row);
        }
        const tier = this.selected;
        [...this.pickRows.children].forEach((row, i) => {
          row.querySelector('[data-pick-label]').textContent = row.dataset.addon ? (tier?.dataset.addonLabel || '') : (addon && qty === 1 ? (this.dataset.singleLabel || this.pickLabel.replace(/\s*#?\[n\]/, '')) : this.pickLabel.replace('[n]', i + 1));
        });
        this.writePickInputs();
      }
      // Item i starts with the main selection; extra items can start in the next colour
      defaultOptions(i) {
        const options = [...this.currentOptions()];
        const colorIndex = this.colorOptionIndex();
        if (this.pickVary && i > 0 && colorIndex >= 0) {
          const values = [...new Set(this.pickVariants.map((v) => v.options[colorIndex]))];
          options[colorIndex] = values[(values.indexOf(options[colorIndex]) + i) % values.length];
        }
        return options;
      }
      // Add-on row: same size (or other shared option) as the main selection when it exists
      setAddonDefaults(row, addon) {
        const main = this.currentOptions();
        const mainByName = {};
        this.pickTemplate.content.querySelectorAll('[data-pick-option]').forEach((el) => { mainByName[(el.getAttribute('aria-label') || '').toLowerCase()] = main[el.dataset.pickOption]; });
        const first = addon.variants.find((v) => v.available) || addon.variants[0];
        const wanted = [...first.options];
        row.querySelectorAll('[data-pick-option]').forEach((el) => {
          const i = Number(el.dataset.pickOption);
          const value = mainByName[(el.getAttribute('aria-label') || '').toLowerCase()];
          if (value && addon.variants.some((v) => v.options[i] === value)) wanted[i] = value;
        });
        const match = addon.variants.find((v) => v.options.every((o, i) => o === wanted[i]));
        const options = match ? wanted : first.options;
        row.querySelectorAll('[data-pick-option]').forEach((el) => pickSet(el, options[el.dataset.pickOption]));
      }
      colorOptionIndex() {
        const swatches = this.pickTemplate?.content.querySelector('.svelt-pick__swatches[data-pick-option]');
        return swatches ? Number(swatches.dataset.pickOption) : -1;
      }
      syncPicks() {
        if (!this.picks) return;
        [...this.pickRows.querySelectorAll('[data-pick]:not([data-addon])')].forEach((row, i) => {
          if (row.dataset.touched === 'true') return;
          const options = this.defaultOptions(i);
          row.querySelectorAll('[data-pick-option]').forEach((el) => pickSet(el, options[el.dataset.pickOption]));
        });
        const addonRow = this.pickRows.querySelector('[data-addon]');
        if (addonRow && addonRow.dataset.touched !== 'true') this.setAddonDefaults(addonRow, this.addons[addonRow.dataset.addon]);
        this.writePickInputs();
      }
      writePickInputs() {
        if (!this.picks) return;
        this.pickInputs.innerHTML = '';
        if (!this.picksActive()) return;
        const counts = new Map();
        [...this.pickRows.children].forEach((row) => {
          const options = [...row.querySelectorAll('[data-pick-option]')].sort((a, b) => a.dataset.pickOption - b.dataset.pickOption).map(pickGet);
          const summary = row.querySelector('[data-pick-summary]');
          if (summary) {
            const swatches = row.querySelector('.svelt-pick__swatches');
            summary.textContent = this.classList.contains('svelt-bundle--picks-rows') ? (swatches ? pickGet(swatches) : '') : ' · ' + options.join(' · ');
          }
          const variant = this.variantsFor(row).find((v) => v.options.every((o, i) => o === options[i]));
          if (variant) counts.set(variant.id, (counts.get(variant.id) || 0) + 1);
          if (variant && row.dataset.addon && this.selected) this.selected.dataset.addonPrice = variant.price;
        });
        [...counts].forEach(([id, quantity], i) => {
          this.pickInputs.insertAdjacentHTML('beforeend', `<input type="hidden" form="${this.dataset.formId}" name="items[${i}][id]" value="${id}"><input type="hidden" form="${this.dataset.formId}" name="items[${i}][quantity]" value="${quantity}">`);
        });
        if (this.pickAddon) { this.updatePrices(); this.showMainPrice(); }
      }
      totals(tier) {
        const qty = Number(tier.dataset.quantity);
        const price = Number(this.dataset.price);
        const compare = Number(this.dataset.comparePrice);
        const addon = tier.dataset.addon ? Number(tier.dataset.addonPrice) || 0 : 0;
        const total = tier.dataset.fixed ? Number(tier.dataset.fixed) : Math.round((price * qty + addon) * (1 - Number(tier.dataset.discount) / 100));
        return { qty: qty + (tier.dataset.addon ? 1 : 0), total, compare: compare * qty + addon };
      }
      // Mirror the selected bundle in the main price (and the sticky bar price)
      showMainPrice() {
        const tier = this.selected;
        if (!tier) return;
        const { qty, total, compare } = this.totals(tier);
        const format = this.dataset.moneyFormat;
        const badge = document.getElementById(`price-${this.dataset.sectionId}`)?.parentElement?.querySelector('[data-price-badge]');
        if (badge && badge.dataset.priceBadge.includes('[percent]') && compare > total) badge.textContent = badge.dataset.priceBadge.replace('[percent]', Math.round((compare - total) * 100 / compare));
        const targets = [document.getElementById(`price-${this.dataset.sectionId}`), document.querySelector('svelt-sticky-atc .svelt-sticky__product > div')];
        targets.forEach((el) => {
          if (!el) return;
          el.querySelector('.svelt-bundle-price')?.remove();
          el.classList.toggle('svelt-has-bundle-price', qty > 1);
          if (qty <= 1) return;
          const wrap = document.createElement('div');
          wrap.className = 'svelt-bundle-price';
          wrap.innerHTML = `<span class="svelt-bundle-price__now"></span>${compare > total && this.dataset.showCompare === 'true' ? '<s class="svelt-bundle-price__was"></s>' : ''}`;
          wrap.querySelector('.svelt-bundle-price__now').textContent = formatMoney(total, format);
          const was = wrap.querySelector('.svelt-bundle-price__was');
          if (was) was.textContent = formatMoney(compare, format);
          el.appendChild(wrap);
        });
      }
      updatePrices() {
        const price = Number(this.dataset.price);
        const compare = Number(this.dataset.comparePrice);
        const format = this.dataset.moneyFormat;
        this.tiers.forEach((tier) => {
          const { qty, total, compare: compareTotal } = this.totals(tier);
          const priceEl = tier.querySelector('[data-tier-price]');
          const compareEl = tier.querySelector('[data-tier-compare]');
          const saveEl = tier.querySelector('[data-tier-save]');
          if (priceEl) priceEl.textContent = formatMoney(total, format);
          const eachEl = tier.querySelector('[data-tier-each]');
          if (eachEl) eachEl.textContent = eachEl.textContent.replace(/^\S+/, formatMoney(Math.round(total / qty), format));
          if (compareEl) compareEl.hidden = compareTotal <= total;
          if (compareEl) compareEl.textContent = formatMoney(compareTotal, format);
          const pctEl = tier.querySelector('[data-tier-save-pct]');
          if (pctEl) { pctEl.hidden = compareTotal <= total; pctEl.textContent = pctEl.dataset.tierSavePct.replace('[percent]', Math.round((compareTotal - total) * 100 / compareTotal)); }
          if (saveEl) saveEl.textContent = saveEl.textContent.replace(/\s\S*$/, ` ${formatMoney(compareTotal - total, format).replace(/[.,]00(?=\D*$)/, '')}`);
        });
      }
    });
  }

  if (!customElements.get('svelt-urgency')) {
    customElements.define('svelt-urgency', class extends HTMLElement {
      connectedCallback() {
        this.output = this.querySelector('[data-countdown]');
        if (!this.output) return;
        this.end = this.dataset.mode === 'session' ? this.sessionEnd() : this.midnight();
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      midnight() { const d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); }
      sessionEnd() {
        const key = 'svelt-countdown-end';
        const minutes = Number(this.dataset.minutes) || 30;
        let end;
        try { end = Number(sessionStorage.getItem(key)); } catch (e) {}
        if (!end || end < Date.now()) {
          end = Date.now() + minutes * 60000;
          try { sessionStorage.setItem(key, end); } catch (e) {}
        }
        return end;
      }
      tick() {
        let left = Math.max(0, this.end - Date.now());
        if (left === 0) this.end = this.dataset.mode === 'session' ? this.sessionEnd() : this.midnight();
        const h = Math.floor(left / 3600000); left -= h * 3600000;
        const m = Math.floor(left / 60000); left -= m * 60000;
        const s = Math.floor(left / 1000);
        this.output.textContent = [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
      }
    });
  }

  if (!customElements.get('svelt-sticky-atc')) {
    customElements.define('svelt-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        const form = document.getElementById(this.dataset.formId);
        this.submit = form?.querySelector('[type="submit"]');
        if (!this.submit) return;
        this.removeAttribute('hidden');
        this.querySelector('[data-sticky-submit]').addEventListener('click', () => {
          if (this.dataset.action === 'add') {
            this.submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.submit.click();
            return;
          }
          // Take the shopper to the offer: colour, size and bundle choices
          const info = form.closest('.product__info-container') || document;
          const target = info.querySelector('variant-selects') || info.querySelector('svelt-bundle') || this.submit;
          const header = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
          window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - header - 24, behavior: 'smooth' });
        });
        // Show once the main button has scrolled above the viewport. A scroll
        // listener (rather than an IntersectionObserver) also handles jumps
        // straight back to the top, which never cross the button.
        let ticking = false;
        this.onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            this.classList.toggle('is-visible', this.submit.getBoundingClientRect().bottom < 0);
            ticking = false;
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
      disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }
    });
  }

  if (!customElements.get('svelt-read-more')) {
    customElements.define('svelt-read-more', class extends HTMLElement {
      connectedCallback() {
        const text = this.querySelector('[data-clamp]');
        const button = this.querySelector('[data-toggle]');
        text.classList.add('is-clamped');
        requestAnimationFrame(() => {
          if (text.scrollHeight <= text.clientHeight + 2) { text.classList.remove('is-clamped'); return; }
          button.hidden = false;
          button.addEventListener('click', () => { text.classList.remove('is-clamped'); button.hidden = true; });
        });
      }
    });
  }
  if (!customElements.get('svelt-size-chart')) {
    customElements.define('svelt-size-chart', class extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('[data-unit]')];
        this.buttons.forEach((b) => b.addEventListener('click', () => this.setUnit(b.dataset.unit)));
      }
      convert(value, kind) {
        const factor = kind === 'length' ? 2.54 : 0.4536;
        return value.replace(/\d+(\.\d+)?/g, (n) => String(Math.round(parseFloat(n) * factor)));
      }
      setUnit(unit) {
        this.buttons.forEach((b) => { const on = b.dataset.unit === unit; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
        const heads = [...this.querySelectorAll('thead th')];
        heads.forEach((th) => { th.innerHTML = ''; th.dataset[unit].split(' (').forEach((part, i) => { if (i) { th.append(document.createElement('br'), `(${part}`); } else { th.append(part); } }); });
        this.querySelectorAll('tbody tr').forEach((tr) => {
          [...tr.children].forEach((cell, i) => {
            const kind = heads[i]?.dataset.kind;
            if (!kind || cell.dataset.value === undefined) return;
            cell.textContent = unit === 'metric' ? this.convert(cell.dataset.value, kind) : cell.dataset.value;
          });
        });
      }
    });
  }
  if (!customElements.get('svelt-carousel')) {
    customElements.define('svelt-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        const step = (dir) => {
          const card = this.track.firstElementChild;
          const width = card ? card.getBoundingClientRect().width + 16 : this.track.clientWidth;
          this.track.scrollBy({ left: dir * width, behavior: 'smooth' });
        };
        this.prev?.addEventListener('click', () => step(-1));
        this.next?.addEventListener('click', () => step(1));
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        };
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() { window.removeEventListener('resize', this.update); }
    });
  }
  if (!customElements.get('svelt-featured')) {
    // Featured product: a colour swatch swaps the photo and points every link at that colour.
    customElements.define('svelt-featured', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const swatch = event.target.closest('.svelt-fp__swatch');
          if (!swatch) return;
          const value = swatch.dataset.value;
          this.querySelectorAll('.svelt-fp__swatch').forEach((el) => el.setAttribute('aria-checked', String(el === swatch)));
          this.querySelectorAll('[data-image]').forEach((el) => { el.hidden = el.dataset.image !== value; });
          this.querySelectorAll('[data-link]').forEach((el) => { el.href = swatch.dataset.url; });
          const label = this.querySelector('[data-selected]');
          if (label) label.textContent = value;
        });
      }
    });
  }
  // Section videos: force muted inline playback and start them when they scroll into view
  const autoplayVideos = () => {
    const videos = [...document.querySelectorAll('.svelt-steps__media video, [data-svelt-autoplay] video, video[data-svelt-autoplay]')];
    if (!videos.length) return;
    const play = (video) => { video.muted = true; video.defaultMuted = true; video.playsInline = true; video.loop = true; const p = video.play(); if (p) p.catch(() => {}); };
    videos.forEach((video) => { video.setAttribute('muted', ''); video.setAttribute('playsinline', ''); video.removeAttribute('controls'); });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) play(e.target); else e.target.pause(); }), { threshold: 0.2 });
      videos.forEach((video) => io.observe(video));
    } else videos.forEach(play);
    // Some browsers only allow playback after the first interaction
    const kick = () => videos.forEach((v) => { if (v.paused && v.getBoundingClientRect().top < window.innerHeight) play(v); });
    ['touchstart', 'scroll', 'click'].forEach((type) => window.addEventListener(type, kick, { passive: true, once: true }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoplayVideos); else autoplayVideos();
  if (!customElements.get('svelt-lengths')) {
    // Length cards: mirror the product's length option, pick it on click, scroll to it on "Find my length"
    customElements.define('svelt-lengths', class extends HTMLElement {
      connectedCallback() {
        this.optionName = (this.dataset.option || 'Length').trim().toLowerCase();
        this.cards = [...this.querySelectorAll('[data-length]')];
        this.cards.forEach((card) => card.addEventListener('click', () => this.pick(card.dataset.length)));
        this.querySelector('[data-find-length]')?.addEventListener('click', () => {
          let target = null;
          if (this.dataset.target !== 'option') {
            const details = document.querySelector('.svelt-sizetable--tab')?.closest('details');
            if (details) { details.open = true; target = details; }
          }
          target = target || this.field();
          if (!target) return;
          const header = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
          window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - header - 24, behavior: 'smooth' });
        });
        this.sync();
        document.addEventListener('change', (event) => { if (event.target.closest?.('variant-selects')) setTimeout(() => this.sync(), 50); });
      }
      field() {
        return [...document.querySelectorAll('variant-selects fieldset')].find((f) => (f.querySelector('legend')?.textContent || '').trim().toLowerCase().startsWith(this.optionName));
      }
      sync() {
        const checked = this.field()?.querySelector('input[type="radio"]:checked')?.value;
        this.cards.forEach((card) => card.setAttribute('aria-checked', String(card.dataset.length === checked)));
      }
      pick(value) {
        const input = this.field()?.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
        if (input && !input.checked) input.click();
        this.cards.forEach((card) => card.setAttribute('aria-checked', String(card.dataset.length === value)));
      }
    });
  }
  // "Size guide" link: open the size guide pop-up, or scroll to the size chart block
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-svelt-size-guide]');
    if (link) {
      event.preventDefault();
      const dialog = link.closest('.product-form__input')?.parentElement?.querySelector('[data-svelt-size-dialog]') || document.querySelector('[data-svelt-size-dialog]');
      if (dialog && typeof dialog.showModal === 'function') {
        const sizeField = link.closest('.product-form__input');
        const chosen = sizeField?.querySelector('input[type="radio"]:checked')?.value;
        dialog.querySelectorAll('[data-size-row]').forEach((row) => row.classList.toggle('is-current', row.dataset.sizeRow === chosen));
        dialog.showModal();
        document.body.classList.add('svelt-modal-open');
        return;
      }
      const details = document.querySelector('svelt-size-chart')?.closest('details');
      if (!details) return;
      details.open = true;
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const gridToggle = event.target.closest('[data-svelt-sizegrid-toggle]');
    if (gridToggle) {
      event.preventDefault();
      const open = !document.body.classList.contains('svelt-sizegrid-open');
      document.body.classList.toggle('svelt-sizegrid-open', open);
      document.querySelectorAll('.svelt-option__guide[data-svelt-sizegrid-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
      return;
    }
    const lenToggle = event.target.closest('[data-svelt-opttable-toggle]');
    if (lenToggle) {
      event.preventDefault();
      const open = !document.body.classList.contains('svelt-opttable-open');
      document.body.classList.toggle('svelt-opttable-open', open);
      document.querySelectorAll('[data-svelt-opttable-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
      return;
    }
    const unitBtn = event.target.closest('[data-units]');
    if (unitBtn) {
      const modal = unitBtn.closest('[data-units-scope], [data-svelt-size-dialog]');
      modal.querySelectorAll('[data-units]').forEach((b) => { const on = b === unitBtn; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
      modal.querySelectorAll('[data-units-panel]').forEach((panel) => { panel.hidden = panel.dataset.unitsPanel !== unitBtn.dataset.units; });
      return;
    }
    const dialog = event.target.closest('[data-svelt-size-dialog]');
    if (dialog && (event.target.closest('[data-svelt-modal-close]') || event.target === dialog)) dialog.close();
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches?.('[data-svelt-size-dialog]')) document.body.classList.remove('svelt-modal-open');
  }, true);

  // Gallery: show only the selected colour's photos (file names carry the colour, e.g. wc-black-1.png)
  const slug = (v) => v.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-');
  const filterMediaByColor = (gallery) => {
    // Longest names first, so "nude-leopard" photos are not taken for "nude"
    const colors = (gallery.dataset.mediaColors || '').split('|').filter(Boolean).map(slug).sort((a, b) => b.length - a.length);
    if (!colors.length) return;
    const section = gallery.closest('section, .shopify-section') || document;
    const fieldsets = [...section.querySelectorAll('variant-selects fieldset')];
    const fs = fieldsets[Number(gallery.dataset.mediaColorPosition) - 1];
    const picked = fs?.querySelector('input:checked')?.value || section.querySelector('variant-selects select')?.value;
    if (!picked) return;
    const current = slug(picked);
    const colorOf = (el) => {
      const img = el.querySelector('img');
      const file = ((img?.getAttribute('src') || '').split('?')[0].split('/').pop() || '').toLowerCase();
      return colors.find((c) => new RegExp(`(^|[^a-z0-9])${c}([^a-z0-9]|$)`).test(file)) || '';
    };
    let firstVisible = null;
    let activeHidden = false;
    gallery.querySelectorAll('[data-media-id], .thumbnail-list__item').forEach((el) => {
      const c = colorOf(el);
      const show = !c || c === current;
      el.classList.toggle('svelt-media-hidden', !show);
      if (el.matches('[data-media-id]')) {
        if (show && !firstVisible) firstVisible = el;
        if (!show && el.classList.contains('is-active')) activeHidden = true;
      }
    });
    if (activeHidden && firstVisible) {
      // Switch the main photo without simulating a click, so the page does not scroll
      gallery.querySelectorAll('[data-media-id]').forEach((el) => el.classList.toggle('is-active', el === firstVisible));
      gallery.querySelectorAll('.thumbnail-list__item').forEach((li) => {
        const btn = li.querySelector('button');
        if (!btn) return;
        if (li.dataset.target === firstVisible.dataset.mediaId) btn.setAttribute('aria-current', 'true'); else btn.removeAttribute('aria-current');
      });
      const list = firstVisible.closest('ul, .slider');
      if (list && list.scrollWidth > list.clientWidth) list.scrollTo({ left: firstVisible.offsetLeft - list.offsetLeft, behavior: 'auto' });
      const thumbs = gallery.querySelector('.thumbnail-list');
      if (thumbs) thumbs.scrollTo({ left: 0, behavior: 'auto' });
    }
  };
  const runMediaFilter = () => {
    const y = window.scrollY;
    document.querySelectorAll('media-gallery[data-media-colors]').forEach(filterMediaByColor);
    if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runMediaFilter); else runMediaFilter();
  document.addEventListener('change', (event) => {
    if (!event.target.closest?.('variant-selects')) return;
    [80, 600].forEach((ms) => setTimeout(runMediaFilter, ms));
  });

  // Buttons that pick a bundle option on this page and scroll to it
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-select-tier]');
    if (!button) return;
    const bundle = document.querySelector('svelt-bundle');
    const tier = bundle?.querySelectorAll('[data-tier]')[Number(button.dataset.selectTier) - 1];
    if (!tier) return;
    event.preventDefault();
    tier.querySelector('input').checked = true;
    tier.querySelector('input').dispatchEvent(new Event('change', { bubbles: true }));
    const header = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
    window.scrollTo({ top: bundle.getBoundingClientRect().top + window.scrollY - header - 24, behavior: 'smooth' });
  });

  // Cart upsell: "Add" opens colour/size pickers when needed, then adds and refreshes the cart (drawer or page)
  const upsellAdd = async (card, button) => {
    const id = Number(card.querySelector('[data-upsell-variant]').value);
    button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
      if (!res.ok) throw new Error('add failed');
      const drawer = card.closest('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        const sections = await fetch('/?sections=cart-drawer,cart-icon-bubble').then((r) => r.json());
        drawer.renderContents({ sections });
      } else {
        window.location.reload();
      }
    } catch (e) {
      button.removeAttribute('aria-busy');
    }
  };
  const upsellSync = (card) => {
    let variants = [];
    try { variants = JSON.parse(card.querySelector('[data-upsell-variants]').textContent); } catch (e) { return; }
    const chosen = [...card.querySelectorAll('[data-upsell-option]')].sort((x, y) => x.dataset.upsellOption - y.dataset.upsellOption).map((el) => el.dataset.value);
    const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
    const add = card.querySelector('[data-upsell-add]');
    if (v) {
      card.querySelector('[data-upsell-variant]').value = v.id;
      const price = card.querySelector('[data-upsell-price]');
      if (price && v.price) price.textContent = v.price;
      const img = card.querySelector('[data-upsell-media] img');
      if (img && v.image) { img.removeAttribute('srcset'); img.src = v.image; }
    }
    if (add) {
      add.disabled = !v || !v.available;
      if (add.dataset.label) add.textContent = v ? (v.available ? `${add.dataset.label} · ${v.price}` : 'Sold out') : add.dataset.prompt;
    }
  };
  // Colour swatches and size buttons in the cart offer
  document.addEventListener('click', (event) => {
    const opt = event.target.closest('[data-upsell-option] [data-value]');
    if (!opt) return;
    event.preventDefault();
    const group = opt.closest('[data-upsell-option]');
    group.dataset.value = opt.dataset.value;
    group.querySelectorAll('[data-value]').forEach((b) => b.setAttribute('aria-checked', String(b === opt)));
    const label = group.parentElement.querySelector('[data-upsell-current]');
    if (label) label.textContent = opt.dataset.value;
    upsellSync(opt.closest('[data-svelt-upsell]'));
  });
  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-upsell-add]');
    if (!add) return;
    event.preventDefault();
    const card = add.closest('[data-svelt-upsell]');
    upsellSync(card);
    if (!add.disabled) upsellAdd(card, add);
  });
})();

/* Require a size choice: nothing preselected, button reads the prompt until a size is picked */
(() => {
  const chosen = new WeakSet();
  const apply = (root = document) => {
    root.querySelectorAll('fieldset[data-require-size]').forEach((fs) => {
      const section = fs.closest('[id^="MainProduct-"], product-info, .product') || document;
      const key = fs.closest('product-info')?.dataset.section || 'main';
      if (window.sveltSizeChosen?.[key]) return;
      fs.querySelectorAll('input[type="radio"]').forEach((i) => { i.checked = false; });
      const value = fs.querySelector('[data-selected-value]');
      if (value) value.textContent = fs.dataset.sizePrompt;
      fs.classList.add('svelt-size-needed');
      const form = (fs.closest('product-info') || document).querySelector('product-form form[action*="/cart/add"]');
      const btn = form?.querySelector('[type="submit"]');
      if (btn) {
        btn.dataset.sveltLocked = '1';
        btn.setAttribute('disabled', 'disabled');
        const label = btn.querySelector('span') || btn;
        if (!btn.dataset.sveltLabel) btn.dataset.sveltLabel = label.textContent.trim();
        label.textContent = fs.dataset.sizePrompt;
      }
    });
  };
  document.addEventListener('change', (e) => {
    const fs = e.target.closest?.('fieldset[data-require-size]');
    if (!fs) return;
    const key = fs.closest('product-info')?.dataset.section || 'main';
    window.sveltSizeChosen = Object.assign(window.sveltSizeChosen || {}, { [key]: true });
    fs.classList.remove('svelt-size-needed');
    const form = (fs.closest('product-info') || document).querySelector('product-form form[action*="/cart/add"]');
    const btn = form?.querySelector('[type="submit"][data-svelt-locked]');
    if (btn) {
      delete btn.dataset.sveltLocked;
      btn.removeAttribute('disabled');
      const label = btn.querySelector('span') || btn;
      if (btn.dataset.sveltLabel) label.textContent = btn.dataset.sveltLabel;
    }
  }, true);
  const run = () => apply();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(run, 0));
  new MutationObserver(() => { if (document.querySelector('fieldset[data-require-size] input:checked') && !Object.keys(window.sveltSizeChosen || {}).length) run(); }).observe(document.body, { childList: true, subtree: true });
})();

/* Customer videos in the buy box: arrows + sound toggle */
document.addEventListener('click', (e) => {
  const arrow = e.target.closest('[data-ugc-prev], [data-ugc-next]');
  if (arrow) {
    const track = arrow.closest('[data-svelt-ugc]').querySelector('[data-ugc-track]');
    const step = track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 8 : track.clientWidth;
    track.scrollBy({ left: arrow.hasAttribute('data-ugc-next') ? step : -step, behavior: 'smooth' });
    return;
  }
  const sound = e.target.closest('[data-ugc-sound]');
  if (sound) {
    const video = sound.parentElement.querySelector('video');
    if (!video) return;
    const on = video.muted;
    document.querySelectorAll('[data-svelt-ugc] video').forEach((v) => { v.muted = true; });
    document.querySelectorAll('[data-ugc-sound]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
    video.muted = !on;
    if (on) { video.play().catch(() => {}); sound.setAttribute('aria-pressed', 'true'); }
  }
});

/* Live stock bar: refresh the low-stock line when the shopper changes colour or size */
if (!customElements.get('svelt-stock')) {
  customElements.define('svelt-stock', class extends HTMLElement {
    connectedCallback() {
      try { this.map = JSON.parse(this.querySelector('[data-stock-map]').textContent); } catch (e) { this.map = {}; }
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.sectionId || !data.variant) return;
          const entry = this.map[data.variant.id];
          const line = this.querySelector('[data-stock-line]');
          if (!line) return;
          const threshold = Number(this.dataset.threshold) || 10;
          line.textContent = entry && entry[0] > 0 && entry[0] <= threshold ? ' ' + this.dataset.line.replace('[count]', entry[0]).replace('[variant]', entry[1]) : '';
        });
      }
    }
    disconnectedCallback() { this.unsub?.(); }
  });
}

/* Coded zone diagram: dotted leader lines from each number to its marker */
(() => {
  const draw = (map) => {
    const svg = map.querySelector('.svelt-zmap__lines');
    if (!svg) return;
    if (window.matchMedia('(max-width: 749px)').matches) { svg.innerHTML = ''; return; }
    const box = map.getBoundingClientRect();
    svg.setAttribute('viewBox', `0 0 ${box.width} ${box.height}`);
    svg.innerHTML = '';
    map.querySelectorAll('.svelt-zmap__label').forEach((label) => {
      const num = label.querySelector('[data-zmap-num]');
      const dot = map.querySelector(`[data-zmap-dot="${label.dataset.zone}"]`);
      if (!num || !dot) return;
      const a = num.getBoundingClientRect(); const b = dot.getBoundingClientRect();
      const right = label.closest('.svelt-zmap__col--right');
      const x1 = (right ? a.left : a.right) - box.left; const y1 = a.top + a.height / 2 - box.top;
      const x2 = b.left + b.width / 2 - box.left; const y2 = b.top + b.height / 2 - box.top;
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', x1); line.setAttribute('y1', y1); line.setAttribute('x2', x2); line.setAttribute('y2', y2);
      svg.appendChild(line);
    });
  };
  const all = () => document.querySelectorAll('[data-zmap]').forEach(draw);
  const init = () => {
    all();
    document.querySelectorAll('[data-zmap] img').forEach((img) => img.complete || img.addEventListener('load', all, { once: true }));
    if ('ResizeObserver' in window) { const ro = new ResizeObserver(all); document.querySelectorAll('[data-zmap]').forEach((m) => ro.observe(m)); } else window.addEventListener('resize', all);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', all);
})();
